export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path != '/car/search') return
  console.log('to', to)

  const dayjs = useDayjs()

  const startDate = to.query.startDate
  const startPlace = to.query.startPlace
  const days = to.query.days
  console.log(startDate, startPlace, days)

  if (startDate && startPlace && days) {
    return
  }
  return navigateTo({
    path: '/car/search',
    query: {
      startDate: startDate || dayjs().format('YYYY-MM-DD'),
      startPlace: startPlace || 99,
      days: days || 1
    }
  })

  // const {
  //   startDate = dayjs().format('YYYY-MM-DD'),
  //   startPlace = 99,
  //   days = 1
  // } = to.query

  // return navigateTo({
  //   path: '/car/search',
  //   query: {
  //     startDate,
  //     startPlace,
  //     days
  //   },
  //   replace: true
  // })
})
